<template>
  <div :class="{'loader-wrapper': true, 'loader-wrapper--active': isLoading, 'loader-wrapper--full-height': fullHeight}">
    <slot />
    <b-loading
      :is-full-page="isFullPage"
      :active.sync="isLoading"
    />
  </div>
</template>

<script>
import Loading from "buefy/src/components/loading/Loading";
import NotificationCmp from "buefy/src/components/notification/Notification";

export default {
  name: "DsLoader",
  components: {
    "b-loading": Loading,
    "b-notification": NotificationCmp
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    fullHeight: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isFullPage: false
    };
  }
};
</script>

<style lang="scss">
.loading-overlay .loading-icon:after {
  top: initial !important;
}
.loader-wrapper {
  position: relative;
  width: 100%;
  &--full-height {
    height: 100%;
  }
  .loading-icon {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 100% !important;
    height: 100% !important;
  }
  .loading-overlay {
    position: absolute;
  }
}
</style>



// WEBPACK FOOTER //
// ../panel-theme/src/js/widgets/ds-loader.vue